import React from "react";


export type TierItem = {
    name: string;
    tier: string;
};

type TierListProps = {
    title?: string;
    items: TierItem[];
    tiers?: string[];
    columns?: number;
};

function TierList({
    title,
    items,
    tiers = ["S", "A", "B", "C", "F"],
    columns = 4,
}: TierListProps) {
    const sortedItems = [...items].sort((a, b) =>
        a.name.localeCompare(b.name)
    );

    function renderTiers(listClass: string) {
        return tiers.map((tier) => {
            const tierItems = sortedItems.filter(
                (item) => item.tier === tier
            );

            if (tierItems.length === 0) return null;

            return (
                <React.Fragment key={tier}>
                    <tr>
                        <th>{tier} Tier</th>
                    </tr>
                    <tr>
                        <td>
                            <ul
                                className={`${listClass} tier-grid`}
                                style={{
                                    "--tier-columns": Math.max(1, Math.floor(columns) || 1),
                                } as React.CSSProperties}
                            >
                                {tierItems.map((item) => (
                                    <li key={item.name}>
                                        {item.name}
                                    </li>
                                ))}
                            </ul>
                        </td>
                    </tr>
                </React.Fragment>
            );
        });
    }

    return (
        <section>
            {title && <h2>{title}</h2>}

            <table className="league-table d-md-block d-lg-none">
                <tbody>
                    {renderTiers("game-tier-list-mobile")}
                </tbody>
            </table>

            <table className="league-table d-none d-lg-block">
                <tbody>
                    {renderTiers("game-tier-list")}
                </tbody>
            </table>
        </section>
    );
}

export default TierList;